module.exports = __webpack_public_path__ + "static/media/e&ohead2.a8c3f6a0.jpg";